(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("EventCarousel", ['jquery', 'jqueryTD', 'jqueryFullpage', 'jqueryFullpageExt'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('jquery'), require('jqueryTD'), require('jqueryFullpage'), require('jqueryFullpageExt'));
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(root.jquery, root.jqueryTD, root.jqueryFullpage, root.jqueryFullpageExt);
    }
}(typeof self !== 'undefined' ? self : this, function ($, jqueryTD, jqueryFullpage, jqueryFullpage, jqueryFullpageExt) {

    // Define debounce function in jQuery
    $.debounce = jqueryTD.Cowboy.debounce;

    var startInitPoint, containerSelector;

    function init () {
        $(containerSelector).fullpage({
            lockAnchors: true,
            anchors: ['top', 'bottom', 'footer'],
            sectionSelector: '.section',
            dragAndMove: true,
            responsiveWidth: startInitPoint,
            scrollOverflow: false,
            responsiveHeight: 500,
            'onLeave': function (origin, destination, direction) {
                window.newsCaro.setNavHeight();

                if(destination === $('.fp-section').length){

                    function indexCompetitionLogo(){
                        if($(window).width() > 1400){
                            $('.dsktp-scroll').addClass('c-s-out');
                            $('footer .competition-logo').addClass('c-in');
                            $('footer').removeClass('scroll');
                        }
                    }
                    $(window).resize(function(){
                        indexCompetitionLogo();
                    });
                    indexCompetitionLogo();

                } else if(destination === ($('.fp-section').length - 1) && direction === "up" ){
                    $('.dsktp-scroll').removeClass('c-s-out');
                    $('footer .competition-logo').removeClass('c-in');
                }
            },
            'afterRender': function(){

                $(window).resize(function(){
                    if($(window).width() > 767 && $(window).width() < 1024 ){
                        $('footer .competition-logo').addClass('index-t-c');
                    } else{
                        $('footer .competition-logo').removeClass('index-t-c');
                    }

                    if($(window).width() > 1023){
                        $('.dsktp-scroll').show();
                        $('footer .competition-logo').addClass('index-c');
                    }
                });
            }
        });

        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
          var evt = document.createEvent('UIEvents');
          evt.initUIEvent('FullpageLoaded', true, false, window, 0);
          window.dispatchEvent(evt);
         } else {
            window.dispatchEvent(new Event('FullpageLoaded'));
         }

        //
        //$(window).trigger('FullpageLoaded');
    }

    return function (options) {
        startInitPoint = options.startInitPoint;
        containerSelector = options.containerSelector;

        if ( $(containerSelector).length !== 0 ) {
            init();
        }
    };

}));



//////////////////
// WEBPACK FOOTER
// ./js/modules/homeFullpage/index.js
// module id = 21
// module chunks = 0